import { useState } from 'react';
import { useDispatch } from 'react-redux';

// action creators
import { getEnvironment } from '@actions/common/actionCreators';
export default () => {

    const [isReady, setIsReady] = useState(false);
    const dispatch = useDispatch();

    const getEnv = () => {
        const getEnvPromise = new Promise((resolve) => {
            dispatch(getEnvironment());
            setTimeout(() => {
                resolve('foo');
            }, 400);
        });
        getEnvPromise.then(function () {
            setIsReady(true);
        });
    };

    return {
        isReady,
        getEnv
    };
};